export * from 'Common/config/order';

/* eslint import/export: 0 */
// Disable rule to override exports without errors
export const SUCCESS_NOTIFICATION_ON_ADD_ITEM = false;
export const SCROLL_TOP_ON_ADD_ITEM = false;
export const USE_TOOLTIP_ON_ADD_ITEM_TO_WISH_LIST = true;
export const SCROLL_TO_TOP = false;
